import React from "react";
import { appActions } from "../../redux/app/app.slice";
import { SearchKind } from "../../model/search/types/SearchKind.enum";
import { AtiraToast } from "../../utils/AtiraToast";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { userSliceSelectors } from "../../redux/user/user.selector";
import { useTranslation } from "react-i18next";
import { SearchInputEntries } from "../InputSearchEntries";
import { Entry } from "../../model/entry/Entry";
import { UseFormSetValue } from "react-hook-form";

type EntriesSearchDropdownProps = {
  setValue: UseFormSetValue<any>;
  required?: boolean;
  isSearchVisible: boolean;
};

export const EntriesSearchDropdown: React.FC<EntriesSearchDropdownProps> = ({
  setValue,
  required = true,
  isSearchVisible,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;

  const onFetchEntries = async (keyword: string) => {
    try {
      const { results: entries } = await dispatch(
        appActions.search({
          userId,
          keyword,
          kind: SearchKind.ENTRY,
        }),
      ).unwrap();

      return entries as Entry[];
    } catch (e: any) {
      AtiraToast.apiError(e);
      console.log(e);
      return [];
    }
  };

  return (
    <SearchInputEntries
      title={t("common.entry")}
      info={t("modules.attachToEntryModal.entryId.info")}
      fetchOptions={onFetchEntries}
      onChange={(e) => setValue("entryId", e?._id)}
      required={required}
      isSearchVisible={isSearchVisible}
    />
  );
};
